function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableediting
 */
import { Plugin } from 'ckeditor5/src/core';
import upcastTable, { ensureParagraphInTableCell, skipEmptyTableRow, upcastTableFigure } from './converters/upcasttable';
import { convertParagraphInTableCell, downcastInsertCell, downcastInsertRow, downcastInsertTable, downcastRemoveRow, downcastTableHeadingColumnsChange } from './converters/downcast';
import InsertTableCommand from './commands/inserttablecommand';
import InsertRowCommand from './commands/insertrowcommand';
import InsertColumnCommand from './commands/insertcolumncommand';
import SplitCellCommand from './commands/splitcellcommand';
import MergeCellCommand from './commands/mergecellcommand';
import RemoveRowCommand from './commands/removerowcommand';
import RemoveColumnCommand from './commands/removecolumncommand';
import SetHeaderRowCommand from './commands/setheaderrowcommand';
import SetHeaderColumnCommand from './commands/setheadercolumncommand';
import MergeCellsCommand from './commands/mergecellscommand';
import SelectRowCommand from './commands/selectrowcommand';
import SelectColumnCommand from './commands/selectcolumncommand';
import TableUtils from '../src/tableutils';
import injectTableLayoutPostFixer from './converters/table-layout-post-fixer';
import injectTableCellParagraphPostFixer from './converters/table-cell-paragraph-post-fixer';
import injectTableCellRefreshPostFixer from './converters/table-cell-refresh-post-fixer';
import injectTableHeadingRowsRefreshPostFixer from './converters/table-heading-rows-refresh-post-fixer';
import '../theme/tableediting.css';
/**
 * The table editing feature.
 *
 * @extends module:core/plugin~Plugin
 */

var TableEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(TableEditing, _Plugin);

  var _super = _createSuper(TableEditing);

  function TableEditing() {
    _classCallCheck(this, TableEditing);

    return _super.apply(this, arguments);
  }

  _createClass(TableEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var model = editor.model;
      var schema = model.schema;
      var conversion = editor.conversion;
      schema.register('table', {
        allowWhere: '$block',
        allowAttributes: ['headingRows', 'headingColumns'],
        isObject: true,
        isBlock: true
      });
      schema.register('tableRow', {
        allowIn: 'table',
        isLimit: true
      });
      schema.register('tableCell', {
        allowIn: 'tableRow',
        allowChildren: '$block',
        allowAttributes: ['colspan', 'rowspan'],
        isLimit: true,
        isSelectable: true
      }); // Figure conversion.

      conversion.for('upcast').add(upcastTableFigure()); // Table conversion.

      conversion.for('upcast').add(upcastTable());
      conversion.for('editingDowncast').add(downcastInsertTable({
        asWidget: true
      }));
      conversion.for('dataDowncast').add(downcastInsertTable()); // Table row conversion.

      conversion.for('upcast').elementToElement({
        model: 'tableRow',
        view: 'tr'
      });
      conversion.for('upcast').add(skipEmptyTableRow());
      conversion.for('editingDowncast').add(downcastInsertRow());
      conversion.for('editingDowncast').add(downcastRemoveRow()); // Table cell conversion.

      conversion.for('upcast').elementToElement({
        model: 'tableCell',
        view: 'td'
      });
      conversion.for('upcast').elementToElement({
        model: 'tableCell',
        view: 'th'
      });
      conversion.for('upcast').add(ensureParagraphInTableCell('td'));
      conversion.for('upcast').add(ensureParagraphInTableCell('th'));
      conversion.for('editingDowncast').add(downcastInsertCell()); // Duplicates code - needed to properly refresh paragraph inside a table cell.

      conversion.for('editingDowncast').elementToElement({
        model: 'paragraph',
        view: convertParagraphInTableCell,
        converterPriority: 'high'
      }); // Table attributes conversion.

      conversion.attributeToAttribute({
        model: 'colspan',
        view: 'colspan'
      });
      conversion.attributeToAttribute({
        model: 'rowspan',
        view: 'rowspan'
      }); // Table heading columns conversion (a change of heading rows requires a reconversion of the whole table).

      conversion.for('editingDowncast').add(downcastTableHeadingColumnsChange()); // Define all the commands.

      editor.commands.add('insertTable', new InsertTableCommand(editor));
      editor.commands.add('insertTableRowAbove', new InsertRowCommand(editor, {
        order: 'above'
      }));
      editor.commands.add('insertTableRowBelow', new InsertRowCommand(editor, {
        order: 'below'
      }));
      editor.commands.add('insertTableColumnLeft', new InsertColumnCommand(editor, {
        order: 'left'
      }));
      editor.commands.add('insertTableColumnRight', new InsertColumnCommand(editor, {
        order: 'right'
      }));
      editor.commands.add('removeTableRow', new RemoveRowCommand(editor));
      editor.commands.add('removeTableColumn', new RemoveColumnCommand(editor));
      editor.commands.add('splitTableCellVertically', new SplitCellCommand(editor, {
        direction: 'vertically'
      }));
      editor.commands.add('splitTableCellHorizontally', new SplitCellCommand(editor, {
        direction: 'horizontally'
      }));
      editor.commands.add('mergeTableCells', new MergeCellsCommand(editor));
      editor.commands.add('mergeTableCellRight', new MergeCellCommand(editor, {
        direction: 'right'
      }));
      editor.commands.add('mergeTableCellLeft', new MergeCellCommand(editor, {
        direction: 'left'
      }));
      editor.commands.add('mergeTableCellDown', new MergeCellCommand(editor, {
        direction: 'down'
      }));
      editor.commands.add('mergeTableCellUp', new MergeCellCommand(editor, {
        direction: 'up'
      }));
      editor.commands.add('setTableColumnHeader', new SetHeaderColumnCommand(editor));
      editor.commands.add('setTableRowHeader', new SetHeaderRowCommand(editor));
      editor.commands.add('selectTableRow', new SelectRowCommand(editor));
      editor.commands.add('selectTableColumn', new SelectColumnCommand(editor));
      injectTableHeadingRowsRefreshPostFixer(model);
      injectTableLayoutPostFixer(model);
      injectTableCellRefreshPostFixer(model, editor.editing.mapper);
      injectTableCellParagraphPostFixer(model);
    }
    /**
     * @inheritDoc
     */

  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableEditing';
    }
  }, {
    key: "requires",
    get: function get() {
      return [TableUtils];
    }
  }]);

  return TableEditing;
}(Plugin);

export { TableEditing as default };